// extracted by mini-css-extract-plugin
module.exports = {"Content":"LanguageTabs-module--Content--q6YB8"};